import React from "react";
export const MyContext = React.createContext(null);
export const ListContext = React.createContext(null);
